define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Renderer",
	"csi/reflection",
], function(declare, _, Renderer, reflection) {

	const EXP_ATTR = "Exp.";
	const EXPR_ATTR = "Expr.";

	return declare(Renderer, {
		processor: null,

		/**
		 * @override
		 * Render referenced expressions from attribute expression
		 */
		_getValue(ctx, h) {
			const node = ctx.getNode();
			const value = node[reflection.ATTR_EXP];
			const expIndex = value.indexOf(EXP_ATTR);

			if (expIndex >= 0) {
				// this does not work in CostScenarioMixin case because the owner is the mixin, and it has an empty value;
				// each derived class overrides the expression as appropriate
				const rc = reflection.getClass(node.ReflectionAttributeOwner);
				const ra = reflection.getClassAttribute(rc, "Exp");
				return ra.getValue();
			}

			const exprIndex = value.indexOf(EXPR_ATTR);

			if (exprIndex >= 0) {
				// the client cache may have the expression node, but all expressions there are translated to Javascript which
				// is hard to read - so better to just open the URL in the node browser
				const rc = reflection.getClass(node.ReflectionAttributeOwner);
				const ra = reflection.getClassAttribute(rc, "Expr");
				return `Expr URL: ${ra.getValue()}`;
			}

			return "";
		}
	});
});